import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/map/neshan"

export const getMapSearch = async (queries) => {
  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/search?q=${encodeURIComponent(query)}`)

  return response.data
}

export const getMapGeocoding = async (queries) => {
  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/geocoding?q=${encodeURIComponent(query)}`)

  return response.data
}

export const getMapReverse = async (queries) => {
  const query =
    stringify(
      queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response = await farasod.get(`${endpoint}/reverse?q=${encodeURIComponent(query)}`)

  return response.data
}